<template>
  <div>
    <span v-if="isArray">
      <span
        v-for="(teamScore, i) in currentScore"
        :key="i"
        class="mx-1"
        :class="colorClass(i, true)"
      >
        {{ teamScore || 0 }}
      </span>
    </span>
    <span v-else>{{ currentScore }}</span>
  </div>
</template>

<script>
export default {
  name: 'ScoreDrawer',
  props: {
    score: [String, Number, Array],
    default: () => '',
  },
  data: () => ({
    currentScore: 0,
  }),
  computed: {
    isArray() {
      return Array.isArray(this.currentScore);
    },
  },
  methods: {
    handleScore() {
      this.currentScore = this.score;

      // If is a string that looks like an array, parse it.
      if (typeof this.score === 'string' && this.score.indexOf(',') > -1) {
        this.currentScore = this.score.split(',');
      }
    },
  },
  watch: {
    score: {
      immediate: true,
      handler() { this.handleScore(); },
    },
  },
};
</script>
